import { useRouter } from "expo-router";
import { useCallback } from "react";

/** The search param the campaign page reads to point at the creators just added. */
export const PRESELECTED_PARAM = "preselected";

/** The user ids in that param; a repeated param is read as one list. */
export const parsePreselected = (
  raw: string | string[] | undefined,
): ReadonlySet<string> =>
  new Set(
    (Array.isArray(raw) ? raw.join(",") : (raw ?? ""))
      .split(",")
      .filter(Boolean),
  );

/**
 * After creators are added to the preselection, opens the campaign page where that
 * step lives, naming them so each gets a hint to send the work order.
 *
 * Programmatic on purpose: it follows the mutation, not a press.
 */
const usePreselectRedirect = (brandId: string, campaignId: string) => {
  const router = useRouter();
  return useCallback(
    (userIds: string[]) => {
      router.push({
        pathname: "/app/(brands)/[brandId]/(main)/campaign/[campaignId]",
        params: {
          brandId,
          campaignId,
          [PRESELECTED_PARAM]: userIds.join(","),
        },
      });
    },
    [router, brandId, campaignId],
  );
};

export default usePreselectRedirect;
